export default __webpack_public_path__ + "static/media/0xa3c322ad15218fbfaed26ba7f616249f7705d945.faae723f.webp";